import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/home/manohar/dev/mall-nuxt/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/manohar/dev/mall-nuxt/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/home/manohar/dev/mall-nuxt/layouts/error.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/home/manohar/dev/mall-nuxt/layouts/login.vue").then(m => m.default || m)),
  mobile: defineAsyncComponent(() => import("/home/manohar/dev/mall-nuxt/layouts/mobile.vue").then(m => m.default || m)),
  sidebar: defineAsyncComponent(() => import("/home/manohar/dev/mall-nuxt/layouts/sidebar.vue").then(m => m.default || m))
}